

@if (vm$ | async; as vm) {
  <div class="uw-dialog-header">
    <h1 class="uw-dialog-heading">{{ "uwsetup.add_a_new_servicing_united_way" | translate }}</h1>
    <button [attr.aria-label]="'aria.close' | translate" cdkFocusInitial mat-icon-button mat-dialog-close>
      <mat-icon>
        close
      </mat-icon>
    </button>
  </div>
  <div class="uw-dialog-content">
    <div [formGroup]="form">
      <div class="uw-field">
        <label for="name" class="uw-label">
          {{ "common.name" | translate }}
        </label>
        <input id="name" class="uw-input" formControlName="name">
      </div>
      <div class="uw-field">
        <label for="externalCatalogSetId" class="uw-label">
          {{ "common.external_id" | translate }}
        </label>
        <input id="externalCatalogSetId" [readonly]="isEdit"
          class="uw-input" formControlName="externalCatalogSetId">
        </div>
        <div class="uw-field">
          <mat-checkbox formControlName="isEnabled">{{ "common.enabled" | translate }}</mat-checkbox>
        </div>
        <div class="uw-field">
          <label for="cfId" class="uw-label">CF</label>
          <select id="cfId" formControlName="cfId" class="uw-select">
            <option value=null selected>{{ "common.not_enabled" | translate }}</option>
            @for (catalog of vm.cfCatalogs; track catalog) {
              <option [value]="catalog.catalogId">{{ catalog.name }}</option>
            }
          </select>
        </div>
        <div class="uw-field">
          <label for="saId" class="uw-label">SA</label>
          <select id="saId" formControlName="saId" class="uw-select">
            <option value=null selected>{{ "common.not_enabled" | translate }}</option>
            @for (catalog of vm.saCatalogs; track catalog) {
              <option [value]="catalog.catalogId">{{ catalog.name }}</option>
            }
          </select>
        </div>
        <div class="uw-field">
          <label for="cat2Id" class="uw-label">CAT2</label>
          <select id="cat2Id" formControlName="cat2Id" class="uw-select">
            <option value=null selected>{{ "common.not_enabled" | translate }}</option>
            @for (catalog of vm.cat2Catalogs; track catalog) {
              <option [value]=" catalog.catalogId">{{ catalog.name }}</option>
            }
          </select>
        </div>
        <div class="uw-field">
          <label for="province" class="uw-label">{{ "common.province" | translate }}</label>
          <select id="province" formControlName="province" class="uw-select">
            @for (province of provinces; track province) {
              <option [value]="province">{{ province }}</option>
            }
          </select>
        </div>
      </div>
    </div>
    <div class="uw-dialog-footer">
      <div class="uw-actions">
        <button class="uw-stroked-button" mat-dialog-close>
          {{ "common.cancel" | translate }}
        </button>
        <button class='uw-default-button' [disabled]="form.pristine || !form.valid || hasInvalidDefaults" (click)="handleSave(form.value)">
          {{ "common.save" | translate }}
        </button>
      </div>
    </div>
  }
